import { StyleSheet } from 'react-native';

export const Colors = {
  // Core backgrounds
  bg: '#070b14',
  bgCard: '#0f1520',
  bgCardAlt: '#161B26',
  bgGlass: 'rgba(15, 21, 32, 0.92)',
  bgInput: 'rgba(255,255,255,0.07)',

  // Primary palette
  sunset: '#F27D26',    // orange accent
  turquoise: '#26D0CE', // cyan accent
  purple: '#A18CD1',    // purple accent
  navy: '#0A0E17',

  // Text
  textPrimary: '#ffffff',
  textSecondary: 'rgba(255,255,255,0.65)',
  textMuted: 'rgba(255,255,255,0.4)',

  // Borders
  border: 'rgba(255,255,255,0.1)',
  borderStrong: 'rgba(255,255,255,0.18)',

  // Category / type
  official: '#F27D26',
  club: '#A18CD1',
  jam: '#26D0CE',

  // Status
  success: '#22c55e',
  error: '#ef4444',
  warning: '#f59e0b',

  // Tab bar
  tabActive: '#F27D26',
  tabInactive: 'rgba(255,255,255,0.4)',
  tabBar: '#0A0E17',
};

export const TonyteGradients = {
  appBg: ['#07101d', '#0a0e17', '#050812'],
  glass: ['rgba(255,255,255,0.12)', 'rgba(255,255,255,0.04)'],
  orangeGlow: ['rgba(242,125,38,0.28)', 'rgba(242,125,38,0.08)', 'rgba(242,125,38,0)'],
  tealGlow: ['rgba(38,208,206,0.22)', 'rgba(38,208,206,0.07)', 'rgba(38,208,206,0)'],
};

export const Typography = {
  xs: 11,
  sm: 13,
  base: 15,
  md: 17,
  lg: 20,
  xl: 24,
  xxl: 30,
  xxxl: 36,

  thin: '100' as const,
  light: '300' as const,
  regular: '400' as const,
  medium: '500' as const,
  semibold: '600' as const,
  bold: '700' as const,
  extrabold: '800' as const,
};

export const Spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  base: 16,
  lg: 20,
  xl: 24,
  xxl: 32,
  xxxl: 48,
};

export const Radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  pill: 999,
};

export const Shadow = {
  card: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.35,
    shadowRadius: 10,
    elevation: 8,
  },
  strong: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.5,
    shadowRadius: 16,
    elevation: 12,
  },
  glow: {
    shadowColor: '#F27D26',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.48,
    shadowRadius: 16,
    elevation: 10,
  },
};

export const GlobalStyles = StyleSheet.create({
  flex1: { flex: 1 },
  screen: { flex: 1, backgroundColor: Colors.bg },
  center: { alignItems: 'center', justifyContent: 'center' },
  row: { flexDirection: 'row', alignItems: 'center' },
  card: {
    backgroundColor: 'rgba(4,8,15,0.72)',
    borderRadius: Radius.xl,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.12)',
    padding: Spacing.base,
    ...Shadow.card,
  },
  sectionTitle: {
    color: Colors.textPrimary,
    fontSize: Typography.lg,
    fontWeight: Typography.bold,
    marginBottom: Spacing.md,
  },
  subText: {
    color: Colors.textSecondary,
    fontSize: Typography.sm,
  },
  pillBadge: {
    backgroundColor: 'rgba(242,125,38,0.18)',
    borderRadius: Radius.pill,
    paddingHorizontal: Spacing.md,
    paddingVertical: Spacing.xs,
  },
  pillBadgeText: {
    color: Colors.sunset,
    fontSize: Typography.xs,
    fontWeight: Typography.semibold,
  },
  inputBase: {
    backgroundColor: 'rgba(255,255,255,0.065)',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.12)',
    borderRadius: Radius.lg,
    paddingHorizontal: Spacing.base,
    paddingVertical: Spacing.md,
    color: Colors.textPrimary,
    fontSize: Typography.base,
  },
  btnPrimary: {
    backgroundColor: '#f27d26',
    borderRadius: Radius.lg,
    paddingVertical: Spacing.md,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },
  btnPrimaryText: {
    color: '#fff',
    fontSize: Typography.base,
    fontWeight: Typography.bold,
  },
  btnOutline: {
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.12)',
    borderRadius: Radius.lg,
    backgroundColor: 'rgba(255,255,255,0.045)',
    paddingVertical: Spacing.md,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },
  btnOutlineText: {
    color: Colors.textSecondary,
    fontSize: Typography.base,
    fontWeight: Typography.medium,
  },
  divider: {
    height: 1,
    backgroundColor: Colors.border,
    marginVertical: Spacing.base,
  },
  avatar: {
    width: 44,
    height: 44,
    borderRadius: Radius.pill,
    backgroundColor: Colors.bgCardAlt,
  },
});
